import { useTLang } from 'intl/intl';

export function useScheduleOrdersTabsLang() {
  return {
    inProgressTab: useTLang({ id: 'scheduleOrder.inProgressTab' }),
    scheduledTab: useTLang({ id: 'scheduleOrder.scheduledTab' }),
  };
}
